import type { ReactNode } from "react";
import Navbar from "@/components/feature/Navbar";
import NewsTicker from "@/components/feature/NewsTicker";
import Footer from "@/components/feature/Footer";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <NewsTicker />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}